export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/rushing-icon.svg?a6fc9c460d0598538acdfd6a3f03db1f";